/** DOM event when the logged-in client's CRM profile changes (socket push). */
export const CLIENT_UPDATED_EVENT = 'catalogofworks:client-updated';

export type ClientUpdatedDetail = {
  clientId?: string;
  tenantId?: string;
};

export function dispatchClientUpdated(detail?: ClientUpdatedDetail): void {
  window.dispatchEvent(new CustomEvent(CLIENT_UPDATED_EVENT, { detail }));
}
